// extracted by mini-css-extract-plugin
export default {"btn":"BtnMainCalc_btn__ZMjoX"};